var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"autocomplete",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.location},on:{"input":function($event){return _vm.fireInputEvent({ address: $event.target.value })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }